// StorePageThree.tsx
import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { updateForm } from "../../../redux/storeFormSlice";
import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import MainTitle from "../../../components/ui/MainTitle";
import SubTitle from "../../../components/ui/SubTitle";
import BackButton from "../../../components/ui/BackButton";
import { useTranslation } from "react-i18next";
import OpeningHoursInputs from "../../../components/store/createStoreForms/OpeningHoursInputs";
import ActiveDaysSelector from "../../../components/store/createStoreForms/ActiveDaysSelector";
import PickupMethodsSelector from "../../../components/store/createStoreForms/PickupMethodsSelector";
import { formatOpeningHoursForSubmit, parseOpeningHoursFromAPI } from "../../../utils/formatOpiningHours";


export interface Page3FormData {
  pickupMethods: { in_store: boolean; drive_thru: boolean };
  openingHours: { day: string; openTime: string | null; closeTime: string | null }[];
}


export default function StorePageThree() {
  const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { pickupMethods, openingHours } = useSelector((state: RootState) => state.storeForm);

  const { register, handleSubmit, setValue, control, watch } = useForm<Page3FormData>({
    defaultValues: {
      pickupMethods,
      openingHours:parseOpeningHoursFromAPI(openingHours)
      // openingHours: daysOfWeek.map((day) => ({ day, openTime: null, closeTime: null })),
    },
  });

  const { fields } = useFieldArray({ control, name: "openingHours" });
  const [activeDays, setActiveDays] = useState<{ [day: string]: boolean }>({});

  useEffect(() => {
  const initActive: { [day: string]: boolean } = {};
  fields.forEach((f) => {
    // إذا كانت openTime أو closeTime موجودة نعتبرها فعّالة، أو افتراضيًا كل الأيام true
    initActive[f.day] = f.openTime !== null && f.closeTime !== null; 
    // أو ببساطة كل الأيام true:
    initActive[f.day] =true
  });
  console.log(initActive)
  setActiveDays(initActive);
}, [fields]);


  const toggleDay = (day: string) => {
    setActiveDays((prev) => {
      const newActive = { ...prev, [day]: !prev[day] };
      if (!newActive[day]) {
        const idx = fields.findIndex((f) => f.day === day);
        setValue(`openingHours.${idx}.openTime`, null);
        setValue(`openingHours.${idx}.closeTime`, null);
      }
      return newActive;
    });
  };

  const onNext = (data: Page3FormData | any) => {
    console.log(data)
    dispatch(updateForm({openingHours:formatOpeningHoursForSubmit(data.openingHours),pickupMethods:data.pickupMethods}));
    navigate(numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page4`:"/owner/add-store/page4");
  };

  return (
    <div className="container p-6 h-[100vh] overflow-auto">
      <form onSubmit={handleSubmit(onNext)} className="flex flex-col gap-6 w-full">
        <MainTitle title={t("public_information")} />

        <SubTitle title={t("pickup_methods_available")} />
        <PickupMethodsSelector watch={watch} setValue={setValue} />
        <SubTitle title={t("opening_hours")} />
        {/* <ActiveDaysSelector daysOfWeek={daysOfWeek} activeDays={activeDays} toggleDay={toggleDay} /> */}

        <OpeningHoursInputs toggleDay={toggleDay} watch={watch} setValue={setValue}   control={control} fields={fields} activeDays={activeDays} setActiveDays={setActiveDays}/>

        <div className="grid grid-cols-2 gap-4">
          <BackButton url={numericOwnerId? `/admin/owners/${numericOwnerId}/add-store/page2`: "/owner/add-store/page2"} height={64} />
          <SubmitButton height={64} label={"next"} />
        </div>
      </form>
    </div>
  );
}
